import * as _ from 'lodash';
import { useEffect, useState } from 'react';
import { Button, ListGroup, ListGroupItem } from 'react-bootstrap';
import UploadFile from '../../center-admin/billing/view-edit/upload-file';

interface IProps {
    files: File[],
    onFilesChange: (files: File[]) => void,
}

const Attachments = (props: IProps) => {
    const [previews, setPreviews] = useState([]);

    useEffect(() => {
        let imageFileTypes = ['image/png', 'image/jpeg', 'image/gif', 'application/pdf'];

        if (props.files.length == 0) {
            setPreviews([]);
        } else {
            let newPreviews = props.files.map(file => {
                if (imageFileTypes.includes(file.type)) {
                    let objectUrl = URL.createObjectURL(file);

                    return objectUrl;
                }

                return null;
            });

            setPreviews(newPreviews);
        }
    }, [props.files]);

    const handleFileChange = (file: File) => {
        let files = _.cloneDeep(props.files);

        if (file != null) {
            files.push(file);
        }

        props.onFilesChange(files);
    };

    const handleFileRemove = (name: string) => {
        let files = _.cloneDeep(props.files).filter(x => x.name != name);
        props.onFilesChange(files);
    };

    return (
        <div>
            {props.files.map((file, index) => {
                let preview = previews[index];

                return (
                    <div style={{ marginBottom: 10 }}>
                        <div>{file.name}</div>
                        <div style={{ display: 'flex' }}>
                            <div style={{ border: '1px solid dimgray', borderRadius: 4 }}>
                                {preview != null && file.type.includes('pdf') == false && (
                                    <img src={preview} style={{ width: 250, height: 250 }} />
                                )}

                                {preview != null && file.type.includes('pdf') && (
                                    <embed
                                        src={preview}
                                        width="250"
                                        height="200" />
                                )}
                            </div>
                            <div style={{ paddingLeft: 10 }}><Button bsStyle='danger' bsSize='sm' onClick={() => handleFileRemove(file.name)}>Remove</Button></div>
                        </div>
                    </div>
                );
            })}

            {props.files.length == 0 && (
                <h4>No files selected...</h4>
            )}

            <UploadFile
                elementName='hospital-charges'
                valid={true}
                disable={false}
                bsSize='btn-md'
                onSelectFile={handleFileChange}
            />
        </div>
    );
}

export default Attachments;